/**
 * * Модель запроса на получение списка пользователей с доступом к очереди задач
 */
export default class GetUserListAccessQueueTaskRequest  {
	/**
	 * * Номер очереди задач
	 */
	QueueTaskId!: string;
	constructor(obj?: Partial<GetUserListAccessQueueTaskRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
